import React from "react";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../../../constants/otherTexts";
import { Confirm } from "../../../../components/confirm";
import { ChangeAccessDeniedAction } from "../../../../actions";
import { connect } from "react-redux";

const ChangeAccessDeniedWarning = props => {
  const { show, message, close } = props;
  return (
    <Confirm
      show={show}
      content={{
        type: "warning",
        icon: "icon mapsa-notification",
        message: message,
        rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
      }}
      rejectHandler={close}
      close={close}
    />
  );
};

const mapStateToProps = store => {
  return {
    show: store.ChangeAccessDenied.warningStatus,
    message: store.ChangeAccessDenied.warningMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(ChangeAccessDeniedAction.closeWarning())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeAccessDeniedWarning);
